const swiperCssUrl = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
const swiperJsUrl  = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';

function loadSwiperCss( )
{
    if ( document.querySelector( `link[ href="${ swiperCssUrl }" ]` ) )
    {

    }
    else
    {
        const link = document.createElement( 'link' );
        link.rel   = 'stylesheet';
        link.href  = swiperCssUrl;
        document.head.appendChild( link );
    }
}

function loadSwiperScript( )
{
    var promise;
    if ( window.Swiper )
    {
        promise = Promise.resolve( );
    }
    else if ( !window.olcSwiperPromise )
    {
        window.olcSwiperPromise = new Promise( ( resolve, reject ) =>
        {
            const existing = document.querySelector( `script[ src="${ swiperJsUrl }" ]` );
            if ( existing )
            {
                existing.addEventListener( 'load', resolve, { once: true } );
                existing.addEventListener( 'error', reject, { once: true } );
                return;
            }
            const script = document.createElement( 'script' );
            script.src   = swiperJsUrl;
            script.defer = true;
            script.addEventListener( 'load', resolve, { once: true } );
            script.addEventListener( 'error', reject, { once: true } );
            document.head.appendChild( script );
        } );
    }
    promise = window.olcSwiperPromise;
    return promise;
}